import { get3PLogo } from '../../logo';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { MondayIcon } from './icon';
import { MondayIconBorderless } from './icon-borderless';

export const mondayConfig: ThirdPartyConfig = {
	displayName: 'Monday',
	id: 'monday',
	resourceType: 'monday-connector',
	icon: get3PLogo(MondayIcon, 'Monday', 'large'),
	iconBorderless: get3PLogo(MondayIconBorderless, 'Monday', 'small'),
	integrationAri: 'ari:cloud:platform::integration/monday',
	requiresOauth: true,
	isEnabled: () => true,
};
